__turbopack_context__.v({
  "greenBorder": "Header-module__RSv_cG__greenBorder",
  "headerText": "Header-module__RSv_cG__headerText",
});
